/**
 * Simplified Chinese language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_ZH_CN_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': '个人资料',
    'lvt.menu.tw_profile': 'TW简介',
    'lvt.menu.company_profile': '公司简介',
    'lvt.menu.my_notifications': '我的通知',
    'lvt.menu.sign_out': '退出',

    // footer
    'lvt.footer.back_to_top': '返回页首',
    'lvt.footer.terms_of_use': '使用条款',
    'lvt.footer.privacy_policy': '隐私政策',
    'lvt.footer.support_information': '支持信息',
    'lvt.footer.transwide_home': 'Transwide主页',
    'lvt.footer.license_nr': '许可证号:',
    'lvt.footer.build_version': '版本号:',

    // order list columns
    'lvt.order_list.header': '订单列表',
    'lvt.order_list.column.shipperCompany': '发货人公司',
    'lvt.order_list.column.reference': '参考号',
    'lvt.order_list.column.status': '状态',
    'lvt.order_list.column.statusReason': '状态原因',
    'lvt.order_list.column.senderCompany': '发货人公司',
    'lvt.order_list.column.senderZipcode': '发货人邮政编码',
    'lvt.order_list.column.senderCity': '发货人城市',
    'lvt.order_list.column.receiverCompany': '收货人公司',
    'lvt.order_list.column.receiverZipcode': '收货人邮政编码',
    'lvt.order_list.column.receiverCity': '收货人城市',
    'lvt.order_list.column.carrierName': '承运人名称',
    'lvt.order_list.column.plannedPickupEndDate': '计划时间提货',
    'lvt.order_list.column.etaPickup': '预计到达时间提货',
    'lvt.order_list.column.delayAtPickup': '延迟提货',
    'lvt.order_list.column.plannedDeliveryEndDate': '计划时间发货',
    'lvt.order_list.column.etaDelivery': '预计到货时间发货',
    'lvt.order_list.column.delayAtDelivery': '延迟发货',
    'lvt.order_list.column.timestamps': '时间戳',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': '已请求',
    'lvt.order_list.status.failed': '错误',
    'lvt.order_list.status.waiting': '有效',
    'lvt.order_list.status.active': '有效',
    'lvt.order_list.status.stopped': '错误',
    'lvt.order_list.status.completed': '已完成',
    'lvt.order_list.status.cancelled': '已取消',
    'lvt.order_list.status.timeout': '已停止',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': '未指定承运人',
    'lvt.order_list.status_reason.plate_number_not_present': '牌照号不存在',
    'lvt.order_list.status_reason.plate_number_not_recognized': '牌照号无法识别',
    'lvt.order_list.status_reason.plate_number_not_operational': '牌照号不可操作',
    'lvt.order_list.status_reason.technical_error_not_posted': '在GH中创建行程时出现技术错误',

    // pagination
    'lvt.order_list.pagination.rows_per_page': '每页显示的行数',
    'lvt.order_list.pagination.first': '首页',
    'lvt.order_list.pagination.previous': '上一页',
    'lvt.order_list.pagination.next': '下一页',
    'lvt.order_list.pagination.last': '末页',
    'lvt.order_list.pagination.no_orders_found': '找不到任何订单',

    // tracked device
    'lvt.map.tracked_device.trailer': '拖车',
    'lvt.map.tracked_device.tractor': '牵引车',
    'lvt.map.tracked_device.mobile': '移动端',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': '打开订单列表',
    'lvt.map.traffic_information.traffic': '交通状况',
    'lvt.map.traffic_information.fast': '快速',
    'lvt.map.traffic_information.slow': '缓慢',
    'lvt.map.pickup_popup.pickup': '提货',
    'lvt.map.pickup_popup.date': '日期',
    'lvt.map.pickup_popup.address': '地址',
    'lvt.map.delivery_popup.delivery': '发货',
    'lvt.map.delivery_popup.date': '日期',
    'lvt.map.delivery_popup.address': '地址',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': '转运至交货点',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': '转运至提货点',
    'lvt.map.current_gps_popup.current_speed': '当前速度',
    'lvt.map.current_gps_popup.average_speed': '平均速度',
    'lvt.map.current_gps_popup.last_location_update': '上次位置更新',
    'lvt.map.current_gps_popup.eta': '预计到货时间',
    'lvt.map.current_gps_popup.planned_time': '计划时间',
    'lvt.map.current_gps_popup.arrival_delay': '到货延误',
    'lvt.map.current_gps_popup.speed_unit': '公里/小时',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': '到达发货地',
    'lvt.order_list.timestamp.not_arrived_at_origin': '未到达发货地',
    'lvt.order_list.timestamp.left_origin': '离开发货地',
    'lvt.order_list.timestamp.not_left_origin': '未离开发货地',
    'lvt.order_list.timestamp.arrived_at_destination': '到达目的地',
    'lvt.order_list.timestamp.not_arrived_at_destination': '未到达目的地',
    'lvt.order_list.timestamp.left_destination': '离开目的地',
    'lvt.order_list.timestamp.not_left_destination': '未离开目的地',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-zh_CN.ts